import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on 19.7.2020
 * @author MHl
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { SelloutTerminationConverter, SelloutTerminationItemConverter, SelloutTerminationSummaryConverter, SelloutTerminationUploadConverter, jsonConversions } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import { Inject } from '@logio/typescript-ioc';
import logger from '../../logger';
export var SelloutTerminationLayer =
/*#__PURE__*/
function () {
  function SelloutTerminationLayer() {
    _classCallCheck(this, SelloutTerminationLayer);
  }

  _createClass(SelloutTerminationLayer, [{
    key: "getTerminations",

    /**
     * Gets the list of all overviews of sellout prices termination
     */
    value: function getTerminations() {
      var _this = this;

      return api(CONSTANTS.API.ENDPOINTS.SELLOUT_TERMINATIONS).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.selloutTerminationConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "getTerminationById",
    value: function getTerminationById(id) {
      var _this2 = this;

      return api(CONSTANTS.API.ENDPOINTS.SELLOUT_TERMINATIONS_ID(id)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this2.selloutTerminationConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "getTerminationItems",
    value: function getTerminationItems(id) {
      var _this3 = this;

      return api(CONSTANTS.API.ENDPOINTS.SELLOUT_TERMINATIONS_ITEMS(id)).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this3.selloutTerminationItemConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "getTerminationSummary",
    value: function getTerminationSummary(id) {
      var _this4 = this;

      return api(CONSTANTS.API.ENDPOINTS.SELLOUT_TERMINATIONS_SUMMARY(id)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this4.selloutTerminationSummaryConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "confirmTermination",
    value: function confirmTermination(terminationId) {
      var _this5 = this;

      return api(CONSTANTS.API.ENDPOINTS.SELLOUT_TERMINATIONS_CONFIRMATION(terminationId)).post({
        id: terminationId
      }, {
        responseType: 'json'
      }).then(function (response) {
        return _this5.selloutTerminationConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "cancelTermination",
    value: function cancelTermination(terminationId) {
      var _this6 = this;

      return api(CONSTANTS.API.ENDPOINTS.SELLOUT_TERMINATIONS_CANCELL(terminationId)).patch({
        id: terminationId
      }, {
        responseType: 'json'
      }).then(function (response) {
        return _this6.selloutTerminationConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "updateTerminationItemTerminate",
    value: function updateTerminationItemTerminate(data) {
      var _this7 = this;

      return api(CONSTANTS.API.ENDPOINTS.SELLOUT_TERMINATION_ITEMS_TERMINATE).patch({
        data: data
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this7.selloutTerminationItemConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "updateTerminationItemDate",
    value: function updateTerminationItemDate(data) {
      var _this8 = this;

      var parsedData = [];
      data.forEach(function (d) {
        return parsedData.push({
          id: d.id,
          pValidTo: d.pValidTo.format('YYYY-MM-DD')
        });
      });
      return api(CONSTANTS.API.ENDPOINTS.SELLOUT_TERMINATION_ITEMS_TERMINATE_DATE).patch({
        data: [].concat(parsedData)
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this8.selloutTerminationItemConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "getUpload",
    value: function getUpload(id) {
      var _this9 = this;

      return api(CONSTANTS.API.ENDPOINTS.SELLOUT_TERMINATION_UPLOADS_ID(id)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this9.selloutTerminationUploadConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(terminationName, terminationFile) {
      var _this10 = this;

      var data = new FormData();
      data.append('name', terminationName);
      data.append('file', terminationFile.data);
      return api(CONSTANTS.API.ENDPOINTS.SELLOUT_TERMINATION_UPLOADS_FILE).post(data, {
        responseType: 'json'
      }).then(function (response) {
        return _this10.selloutTerminationUploadConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "getSummary",
    value: function getSummary(terminationId) {
      var _this11 = this;

      return api(CONSTANTS.API.ENDPOINTS.SELLOUT_TERMINATION_SUMMARIES(terminationId)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this11.selloutTerminationSummaryConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "confirm",
    value: function confirm(terminationId, releaseId) {
      var _this12 = this;

      return api(CONSTANTS.API.ENDPOINTS.SELLOUT_TERMINATION_CONFIRMATION(terminationId, releaseId)).post(undefined, {
        responseType: 'json'
      }).then(function (response) {
        return _this12.selloutTerminationSummaryConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return SelloutTerminationLayer;
}();

__decorate([Inject, __metadata("design:type", SelloutTerminationConverter)], SelloutTerminationLayer.prototype, "selloutTerminationConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutTerminationItemConverter)], SelloutTerminationLayer.prototype, "selloutTerminationItemConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutTerminationSummaryConverter)], SelloutTerminationLayer.prototype, "selloutTerminationSummaryConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutTerminationUploadConverter)], SelloutTerminationLayer.prototype, "selloutTerminationUploadConverter", void 0);